// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"745":"0ebbe133","4110":"a508b847","6198":"39b23a66","9287":"5bb44525","9608":"5bb44525"}[chunkId] + ".chunk.css";
};